/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://rb2cvtixsa.execute-api.us-west-2.amazonaws.com/develop",
            "region": "us-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://6tipgnnbgvb5jmku3p64fd4lve.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-west-2:cd0ea8b0-f69f-4ccf-92a3-f1498bbdba0f",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_zD3yqbAAJ",
    "aws_user_pools_web_client_id": "5i3q4jlhcpss0rctrrk1dn0eqf",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
